import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'
import moment from 'moment'

import ControlsLikeContainer from 'components/controls-like-container/controls-like-container'

import {
	dismissAnnouncement,
	likeAnnouncement,
	openModal
} from 'state/actions'

import {
	isMobile
} from 'utils'

import { nl2br } from 'utils'

class DashboardAnnouncement extends Component {
	state = {
		isVisible: false,
		contentHeight: 70
	}

	contentRef = null

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				isVisible: true
			})

			this.setMaxHeight()
		}, 2000)
	}

	UNSAFE_componentWillUpdate = nextProps => {
		const currentAnnouncementId = this.props.announcement ? this.props.announcement.id : null
		const nextAnnouncementId = nextProps.announcement ? nextProps.announcement.id : null

		if (currentAnnouncementId && currentAnnouncementId !== nextAnnouncementId) {
			setTimeout(_ => {
				this.setState({
					isVisible: true
				})
			}, 300)
		}
	}

	setMaxHeight = _ => {
		const {
			contentHeight
		} = this.state

		setTimeout(_ => {
			const newContentHeight = this.contentRef ? (this.contentRef.getBoundingClientRect().height + 30) : 70

			if (contentHeight !== newContentHeight) {
				this.setState({
					contentHeight: newContentHeight
				})
			}
		}, 2)
	}

	dismissAnnouncement = _ => {
		const {
			announcement,
			userData,
			dismissAnnouncement
		} = this.props

		this.setState({
			isVisible: false
		})

		setTimeout(_ => {
			dismissAnnouncement(announcement, userData)
		}, 200)
	}

	deleteAnnouncement = _ => {
		this.props.openModal('delete', 'bulletin', this.props.announcement)
	}

	editAnnouncement = _ => {
		this.props.openModal('edit', 'feedback', {
			announcement: this.props.announcement,
			isAnnouncement: true
		})
	}

	handleCreateProject = _ => {
		this.props.openModal('create', 'project', {
			account_id: this.props.currentAccount.id,
			folderChain: this.props.folderChain
		})
	}

	render() {
		const {
			announcement,
			likeAnnouncement,
			userData,
			allUsers
		} = this.props

		const {
			isVisible,
			contentHeight
		} = this.state

		let announcementClassName = "widget box dashboard-announcement controls-container-container"

		if (isVisible) {
			announcementClassName += ' visible'
		}

		if (announcement && !announcement.copy) {
			announcementClassName += ' no-copy'
		}

		const {
			is_onboarding,
			user_id
		} = announcement

		const canEditAnnouncement = user_id === userData.id && !is_onboarding

		const announcementUser = allUsers[announcement.user_id]

		let metaText = null

		if (!canEditAnnouncement && announcementUser && !is_onboarding) {
			metaText = `by ${announcementUser.first_name} ${announcementUser.last_name}, `

			const createdMoment = moment(announcement.created_at)

			const comparisonCreatedMoment = moment(createdMoment).startOf('day')

			const daysAgo = moment().startOf('day').diff(comparisonCreatedMoment, 'days')

			if (daysAgo == 0) {
				metaText += 'today at '
				metaText += createdMoment.format('h:mm a')
			} else if (daysAgo == 1) {
				metaText += 'yesterday at '
				metaText += createdMoment.format('h:mm a')
			} else {
				metaText += createdMoment.format('Do MMMM, h:mm a')
			}
		}

		const controls = (
			<ControlsLikeContainer
				likeCallback={_ => { likeAnnouncement(announcement, userData) }}
				likersIds={announcement.liker_ids}
				allUsers={allUsers}
				thisUser={userData}
				canEdit={canEditAnnouncement}
				editCallback={this.editAnnouncement}
				deleteCallback={this.deleteAnnouncement}
				metaText={metaText}
			/>
		)

		const {
			title = '',
			copy = ''
		} = (() => {
			if (!announcement) {
				return {}
			}

			if (!announcement.is_onboarding) {
				return announcement
			}

			return {
				title: `Welcome to Hassl, ${userData.first_name}!`,
				copy: `It all starts with a <strong>project</strong> - such as a client brief, website or even a house! Click here to create one.`
			}
		})()

		return (
			<div
				className={announcementClassName}
				style={{
					maxHeight: contentHeight + 'px',
					cursor: is_onboarding ? 'pointer' : undefined
				}}
				onClick={e => {
					if (is_onboarding) {
						e.stopPropagation()

						this.handleCreateProject()
					}
				}}
			>
				<button
					className="close-modal"
					onClick={this.dismissAnnouncement}
				>
					×
				</button>
				<span className="icon-container">
					<Icon name="bullhorn" />
				</span>
				<div
					ref={ref => this.contentRef = ref}
					className="inner"
				>
					<h3>
						{title}
						{!isMobile() ?
							controls
							: null}
					</h3>
					{copy ?
						<p dangerouslySetInnerHTML={{ __html: nl2br(copy) }} />
						: null}
					{isMobile() ?
						controls
						: null}
				</div>
			</div>
		)
	}
}

export default connect(null, {
	dismissAnnouncement,
	likeAnnouncement,
	openModal
})(DashboardAnnouncement)